<script>
export default {
  name: 'Section',
  props: ['text','underlined'],
}
</script>


<template>
  <section>
    <div v-if="!underlined" class="title">
      {{text}}
    </div>
    <div v-else class="title underlined">
      {{text}}
    </div>
    <body class="section-body">
        <slot name="body"></slot>
    </body>
  </section>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

.title{
  // margin-top: 20px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1px;
  width: 100%;
  // padding: 0 0 0 3px;
  color: $main;
}

.underlined{
  border-bottom: 1px solid $main;
}

.section-body{
  margin: 10px 0 0 0;
}

</style>
